package com.castly.admin.ui.components

import androidx.compose.runtime.Composable
import com.castly.admin.ui.theme.AppTheme
import com.castly.admin.ui.theme.BorderRadius
import com.castly.admin.ui.theme.Shadow
import com.castly.admin.ui.theme.Spacing
import com.castly.admin.ui.theme.Typography
import com.castly.admin.ui.theme.themeTransition
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun StatCard(
    title: String,
    value: String,
    icon: @Composable () -> Unit,
    subtitle: String? = null,
    details: Map<String, Int>? = null,
    isLoading: Boolean = false,
    onClick: (() -> Unit)? = null
) {
    val colors = AppTheme.colors

    Div({
        if (onClick != null) {
            onClick { onClick() }
        }
        style {
            backgroundColor(Color(colors.surface))
            borderRadius(BorderRadius.xl)
            padding(Spacing.xxl)
            border(1.px, LineStyle.Solid, Color(colors.border))
            property("box-shadow", Shadow.sm)
            themeTransition()
            if (onClick != null) {
                cursor("pointer")
                property("transition", "background-color 0.2s, transform 0.15s, box-shadow 0.2s")
            }
        }
        if (onClick != null) {
            onMouseOver { it.currentTarget.asDynamic().style.boxShadow = Shadow.md; it.currentTarget.asDynamic().style.transform = "translateY(-1px)" }
            onMouseOut { it.currentTarget.asDynamic().style.boxShadow = Shadow.sm; it.currentTarget.asDynamic().style.transform = "none" }
        }
    }) {
        // Header: icon + value
        Div({
            style {
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                gap(Spacing.lg)
                marginBottom(Spacing.sm)
            }
        }) {
            // Icon circle
            Div({
                style {
                    width(50.px)
                    height(50.px)
                    backgroundColor(Color(colors.surfaceHover))
                    property("border-radius", BorderRadius.circle)
                    display(DisplayStyle.Flex)
                    alignItems(AlignItems.Center)
                    justifyContent(JustifyContent.Center)
                    color(Color(colors.primary))
                    property("flex-shrink", "0")
                }
            }) {
                icon()
            }

            Div {
                if (isLoading) {
                    Span({
                        style {
                            color(Color(colors.textMuted))
                            fontSize(Typography.base)
                        }
                    }) { Text("Loading...") }
                } else {
                    // Value
                    Div({
                        style {
                            fontSize(Typography.xxl)
                            fontWeight("700")
                            color(Color(colors.text))
                            property("line-height", "1.2")
                        }
                    }) { Text(value) }
                }
            }
        }

        // Title
        Div({
            style {
                fontSize(Typography.sm)
                color(Color(colors.textMuted))
                marginBottom(if (details != null || subtitle != null) Spacing.sm else 0.px)
            }
        }) { Text(title) }

        // Subtitle
        if (subtitle != null) {
            Div({
                style {
                    fontSize(Typography.xs)
                    color(Color(colors.textMuted))
                }
            }) { Text(subtitle) }
        }

        // Details breakdown
        if (details != null && details.isNotEmpty()) {
            Div({
                style {
                    marginTop(Spacing.sm)
                    paddingTop(Spacing.sm)
                    property("border-top", "1px solid ${colors.border}")
                }
            }) {
                details.forEach { (label, count) ->
                    Div({
                        style {
                            display(DisplayStyle.Flex)
                            justifyContent(JustifyContent.SpaceBetween)
                            fontSize(Typography.xs)
                            color(Color(colors.textMuted))
                            padding(2.px, 0.px)
                        }
                    }) {
                        Span { Text(label) }
                        Span({ style { fontWeight("600"); color(Color(colors.text)) } }) { Text("$count") }
                    }
                }
            }
        }
    }
}
